import { render, staticRenderFns } from "./SurveyLabel.vue?vue&type=template&id=bc383102&"
import script from "./SurveyLabel.vue?vue&type=script&lang=js&"
export * from "./SurveyLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports